export const routes = [
  // {
  //   path: '/inscricao/confirmacao/:id',
  //   component: () => import('./components/confirmacao'),
  //   name: 'inscricao.confirmacao'
  // },
  // {
  //   path: '/inscricao/validacao/:id',
  //   component: () => import('./components/validacao'),
  //   name: 'inscricao.confirmacao'
  // },
  {
    path: "/inscricao/auth/listar",
    component: () => import("./components/listar"),
    name: "inscricao.lsitar",
    meta: {
      requiresAuth: true,
    },
  },
];
